import { defineMessages } from 'react-intl';

export default defineMessages({
  getSubscription: {
    id: 'widget.overlay-buttons.get-subscription',
    defaultMessage: 'Subscribe {price}/mo.',
  },
  getSubscriptionSmall: {
    id: 'widget.overlay-buttons.get-subscription-small',
    defaultMessage: 'Subscribe',
  },
  buyFrom: {
    id: 'widget.overlay-buttons.buy-from',
    defaultMessage: 'Buy from {price}',
  },
  buy: {
    id: 'widget.overlay-buttons.buy',
    defaultMessage: 'Buy {price}',
  },
  rent: {
    id: 'widget.overlay-buttons.rent',
    defaultMessage: 'Rent {price}',
  },
  watchPreview: {
    id: 'widget.overlay-buttons.watch-preview',
    defaultMessage: 'Watch Preview',
  },
  watchTrailer: {
    id: 'widget.overlay-buttons.watch-trailer',
    defaultMessage: 'Watch Trailer',
  },
  startWatching: {
    id: 'widget.overlay-buttons.start-watching',
    defaultMessage: 'Watch Now',
  },
  playVideo: {
    id: 'widget.overlay-buttons.play-video',
    defaultMessage: 'Play Video',
  },
  nextVideo: {
    id: 'widget.overlay-buttons.next-video',
    defaultMessage: 'Next Video',
  },
  preview: {
    id: 'widget.overlay-buttons.preview',
    defaultMessage: 'Preview',
  },
  trailer: {
    id: 'widget.overlay-buttons.trailer',
    defaultMessage: 'Trailer',
  },
  allVideos: {
    id: 'widget.overlay-buttons.all-videos',
    defaultMessage: 'All videos',
  },
  continueWatching: {
    id: 'widget.overlay-buttons.continue-watching',
    defaultMessage: 'Resume Video',
  },
});



// WEBPACK FOOTER //
// ./src/shared/translations/overlay-common-translations.js